module.exports = __webpack_public_path__ + "static/media/exchange-03.b065d510.webm";